// Imports
import { faPhone } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import styled from 'styled-components/macro';
import { useAppSelector } from '../../../../../../../shareables/foundation/front-end/redux/hooks';
import { GetAccountResponse } from '../../../../../../../shareables/types/api/main/website/page/type/207/account/get';
import formatPhoneNumber from '../../../../../../../shareables/utils/format-phone-number';
import ContactInfo from '../../shared-components/contact-info';


// Styled components
const Container = styled.div`
	em {
		font-size: 0.8rem;
		
		a {
			color: inherit;
			text-decoration: none;
			
			& :hover,
			:focus {
				color: inherit;
			}
		}
	}
`;

const Address = styled.div`
	display: inline-block;
	text-align: left;
`;

const ExtraAddressDetail = styled.em`
	display: block;
`;


// Define the accepted props
interface Props {
	addresses: GetAccountResponse['internalAddresses'] | GetAccountResponse['externalAddresses'];
}


// Function component
const Addresses: React.FC<Props> = ({ addresses }) => {
	// Use Redux functionality
	const website = useAppSelector((state) => state.self.website);
	
	
	// Return JSX
	return (
		<React.Fragment>
			{addresses.map((address, i) => (
				<Container key={i}>
					<Address>
						{address.formatted.split('\n').map((line, key) => (
							<div key={key}>{line}</div>
						))}
						{address.extraAddressDetail && (
							<ExtraAddressDetail>
								{address.extraAddressDetail.label}: {address.extraAddressDetail.value}
							</ExtraAddressDetail>
						)}
						{address.homePhone && (
							<em>
								<ContactInfo
									contactDetails={[
										{
											icon: faPhone,
											href: `tel:${address.homePhone}`,
											text: formatPhoneNumber(address.homePhone, website?.country.callingCode ?? 1),
										},
									]}
								/>
							</em>
						)}
						{i < addresses.length - 1 && <hr />}
					</Address>
				</Container>
			))}
		</React.Fragment>
	);
};

export default Addresses;
